import Repository from "./repoIrricrops";
import _ from "lodash";

export default class Model {
  constructor(params){
    this.resource   = params.resource;
    this.inputs     = params.inputs || [];
    this.relations  = params.relations || [];
    this.path       = params.path || null;
    this.transform  = params.transform || null;
    this.varName    = params.varName || null;
    this.grouped    = params.grouped !== undefined ? params.grouped: false;

    _.forEach(this.inputs, input => {
      input.search = "";
    })
  }

  new(){
    var newObj = {};
    _.forEach(this.inputs, input=>{
      if(input.modelTo == undefined){
        newObj[input.nameAttr] = input.default;
      }
    })
    newObj.id = null;
    return newObj;
  }

  getDefault(attr){
      var p = _.find(this.inputs, {nameAttr: attr});
      if(p){
        return p;
      }
      console.log("getDefault: not found");
      return null;
  }

  all(payload) {
    return Repository.get(`${this.resource}`, payload);
  }

  get(id, payload){
    return Repository.get(`${this.resource}/${id}`, payload);
  }

  add(payload) {
    return Repository.post(`${this.resource}`, payload);
  }

  save(id, payload){
    return Repository.put(`${this.resource}/${id}`, payload);
  }

  saveOrAdd(payload){
    if(_.isNumber(payload.id)) return this.save(payload.id, payload);
    else return this.add(payload);
  }

  delete(id){
    return Repository.delete(`${this.resource}/${id}`);
  }

}
